let activeRequests = 0;

function updateLoadingState() {
  if (typeof document === "undefined") return;

  if (activeRequests > 0) {
    document.body.setAttribute("data-global-loading", "true");
  } else {
    document.body.removeAttribute("data-global-loading");
  }

  window.dispatchEvent(
    new CustomEvent("global-loading-change", {
      detail: { isLoading: activeRequests > 0 },
    }),
  );
}

export function startGlobalLoading() {
  activeRequests += 1;
  updateLoadingState();
}

export function stopGlobalLoading() {
  activeRequests = Math.max(0, activeRequests - 1);
  updateLoadingState();
}
